<template>
  <v-navigation-drawer
    app
    clipped
    v-model="isVisible"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6">Hermes</v-list-item-title>

        <v-list-item-subtitle>La plateforme de mobilité</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list nav>
      <v-list-item
        v-for="link in links"
        :key="link.title"
        :to="link.path"
      >
        <v-list-item-icon>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ link.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="pa-3">
        <v-img :src="require('../assets/undraw_traveling_re_weve.svg')"></v-img>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'TheDrawer',

  props: {
    value: Boolean,
  },

  data: () => ({
    links: [
      { title: 'Demandes', icon: 'mdi-folder', path: '/requests' },
      { title: 'Enseignants relais', icon: 'mdi-human-male-board', path: '/teachers' },
      { title: 'Partenaires', icon: 'mdi-handshake', path: '/partners' },
      { title: 'Sociétés', icon: 'mdi-office-building', path: '/companies' },
      { title: 'Statistiques', icon: 'mdi-chart-bar', path: '/statistics' },
    ],
  }),

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
